import type { ReactNode } from "react";
import { MarkMotif } from "@mineoptics/brand/logo";
import { Seo } from "./Seo";
import { useReveals } from "@/lib/motion";

interface Props {
  title: string;
  description: string;
  path: string;
  updated: string;
  children: ReactNode;
}

/** Plain, readable layout for the privacy policy and the terms. */
export function LegalPage({ title, description, path, updated, children }: Props) {
  const scope = useReveals();

  return (
    <div ref={scope}>
      <Seo title={title} description={description} path={path} />
      <section data-theme="light" className="bg-bg">
        <div className="shell grid gap-12 pb-28 pt-40 md:pb-40 md:pt-56 lg:grid-cols-[1fr_1.6fr]">
          <div>
            <p data-fade data-now className="eyebrow eyebrow-mark mb-6 text-mute">
              Legal
            </p>
            <h1 data-split data-now data-delay="0.1" className="title">
              {title}
            </h1>
            <p data-fade data-now data-delay="0.4" className="eyebrow mt-8 text-mute">
              Last updated: {updated}
            </p>
            <MarkMotif rings={4} strokeWidth={0.6} className="mt-20 hidden h-72 w-72 text-fg/30 lg:block" />
          </div>
          <div data-fade data-now data-delay="0.3" className="prose-legal max-w-[68ch] [&>section:first-child>h2]:mt-0">
            {children}
          </div>
        </div>
      </section>
    </div>
  );
}
